import { useMediaQuery, useTheme } from '@mui/material';
import styles from './AuthLayout.module.scss';
import { PropsWithChildren } from 'react';
import { getLogoPath } from '../../../../utils/utils';

interface AuthLayoutProps extends PropsWithChildren {

}

function AuthLayout(props:AuthLayoutProps) {
  const { children } = props;

  const theme = useTheme();
  const mq = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <div>
      <div className={styles.authLayoutContent}>
        <header>
          <img src={getLogoPath()} className={styles.authHeaderLogo} alt="Skidattl Logo" />
        </header>
        {children}
      </div>
    </div>
  );
}

export default AuthLayout;
